import RadialChartComponent from '@/components/RadialChart';
import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import './style.scss';

const ChatBotLearningMapButton: React.FC = () => {
    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    return (
        <Link className="chatButtonContainer" to="/profile/learningmap">
            <div className="learningMap">
                <div className="infoContainer">
                    <h1 className="title">{strings.LEARNING_GOAL}</h1>
                    <p className="duration">{strings.WEEKLY}</p>
                </div>

                <RadialChartComponent chartType={Constants.radialChartTypes.LEARNING_MAP_CHART} progressBarColor={'#c4c4c4'} radius={40} />

                <i className="material-icons align-middle arrow">{Constants.icons.ARROW_RIGHT}</i>
            </div>
        </Link>
    );
};

export default ChatBotLearningMapButton;
